export default function formatAssignedUserLabel(user) {
  if (!user) {
    return '';
  }

  const fullName = [user.first_name, user.last_name]
    .filter(Boolean)
    .join(' ')
    .trim();

  if (fullName) {
    return fullName;
  }

  if (user.username) {
    return user.username;
  }

  return user.email || 'Unknown user';
}
